import React from "react";

const SortIcon = ({ width = 15, height = 14, color = "#242424" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 15 14" fill="none">
      <path
        d="M3.625 0.625V12.625M3.625 12.625L0.625 9.625M3.625 12.625L6.625 9.625M11.125 12.625V0.625M11.125 0.625L8.125 3.625M11.125 0.625L14.125 3.625"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortIcon;
